import { Injectable } from '@angular/core';
import { Actions, createEffect, Effect, ofType } from '@ngrx/effects';
import { map, switchMap } from 'rxjs/operators';
import * as AuthActions from './auth.actions';
import { AppService } from 'src/app/app.service';
import { Auth } from 'aws-amplify';
import { User } from './auth.models';
import { Router } from '@angular/router';
import { clearGoals } from '../goal/goal.actions';
import { ClearResumes } from '../resume/resume.actions';
import { clearAssessment } from '../assessment/assessment.actions';


@Injectable()
export class AuthEffects {
  private cognitoUser: any = null;

  preAuthCheck$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AuthActions.authenticateUserPrecheck),
      switchMap(() => {
        return Auth.currentAuthenticatedUser()
          .then((res) => {
            const user: User = {
              email: res.attributes.email,
              email_verified: res.attributes.email_verified,
              family_name: res.attributes.family_name,
              given_name: res.attributes.given_name,
              sub: res.attributes.sub,
              username: res.username
            };
            return AuthActions.authenticateUserSuccess({user});
          })
          .catch(() => AuthActions.authenticateUserFailure({error: null}));
      })
    );
  });

  loadAuths$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AuthActions.authenticateUser),
      switchMap((action) => {
        return Auth.signIn(action.username, action.password)
          .then(
            (res: any) => {
              const user: User = {
                email: res.attributes.email,
                email_verified: res.attributes.email_verified,
                family_name: res.attributes.family_name,
                given_name: res.attributes.given_name,
                sub: res.attributes.sub,
                username: res.username
              };
              this.router.navigate(['/dashboard']);
              return AuthActions.authenticateUserSuccess({user});
            }
          )
          .catch((error: any) => AuthActions.authenticateUserFailure({error: error.message}))
      })
    );
  });

  signUpUser$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AuthActions.signUpUser),
      switchMap((action) => {
        return Auth.signUp(action.userData)
          .then((res) => {
            this.cognitoUser = res;
            const message = `A confirmation code has been sent to you via ${res.codeDeliveryDetails.AttributeName} to ${res.codeDeliveryDetails.Destination}`;
            return AuthActions.signUpUserSuccess({message, authState: 'CONFIRM_SIGN_UP' });
          })
      })
    );
  });


  constructor(private actions$: Actions, private authService: AppService<any>, private router: Router) {}

}
